import { HandCoinsIcon } from "lucide-react"
import { useTranslation } from "react-i18next"

import { AppSkeletonTable } from "@/components/commons/app-skeleton-table"
import { DataTable } from "@/components/ui/data-table"
import {
  useDefaulterSearchParams,
  useDefaultersSubscription,
} from "@/hooks"

import { AppPaginationWithoutTotal } from "../commons"
import { DefaultersDownload } from "./download"
import { createDefaultersSubscriptionColumns } from "./subscription-columns"
export const DefaultersRecurringTable = () => {
  const { t } = useTranslation()
  const { params } = useDefaulterSearchParams()
  const refetch =
    params.tab === "recurring" && params.refetch === "true"
  const { data, isFetching } = useDefaultersSubscription(
    params,
    refetch
  )
  if (isFetching) {
    return (
      <AppSkeletonTable
        withHeaderButton
        withAction
        columns={7}
      />
    )
  }
  const pagination = {
    hasNext: data?.hasNext || false,
    currentPage: params.page,
    tab: params.tab,
  }
  if (!refetch) {
    return (
      <div className="mt-4 flex flex-1 flex-col items-center justify-center gap-4 text-muted-foreground">
        <HandCoinsIcon size={48} strokeWidth={1.5} />
        <p className="text-center">
          Para visualizar transações de recorrência efetue
          uma busca.
        </p>
      </div>
    )
  }

  return (
    <>
      <DataTable
        data={data?.defaulterSubscriptionList}
        columns={createDefaultersSubscriptionColumns(t)}
        showColumnVisibility
        actionChildren={
          <DefaultersDownload mode="subscription" />
        }
      />
      <AppPaginationWithoutTotal pagination={pagination} />
    </>
  )
}
